import { Tooltip } from '@mui/material';
import { formatPrice, formatDifference } from './utils';
import { PriceComparisonCellProps } from './PriceComparisonCell.types';

/**
 * Renders a price comparison cell showing actual price and difference from mode
 * In summary mode, displays only the mode price. Otherwise shows actual price and difference.
 */
export function PriceComparisonCell({ fuelPrice, brandName, isSummary = false }: PriceComparisonCellProps) {
  if (!fuelPrice) {
    return <span>-</span>;
  }

  if (isSummary) {
    return (
      <Tooltip title="Мода ціни" placement="top">
        <div className="price-comparison-price-single">{formatPrice(fuelPrice.mode_price)}</div>
      </Tooltip>
    );
  }

  const difference = parseFloat((fuelPrice.difference_from_mode as string) || '0');
  if (difference === 0) {
    return <span>-</span>;
  }

  return (
    <div className="price-comparison-price-container">
      <div className="price-comparison-price-grid">
        <Tooltip title="Ціна стели" placement="top">
          <div className="price-comparison-price-value price-comparison-mode-price">
            {formatPrice(fuelPrice.actual_price)}
          </div>
        </Tooltip>
        <Tooltip title={`Різниця із ${brandName}`} placement="top">
          <div
            className={`price-comparison-difference-value ${
              difference > 0
                ? 'price-comparison-difference-positive'
                : difference < 0
                  ? 'price-comparison-difference-negative'
                  : ''
            }`}
          >
            {formatDifference(fuelPrice.difference_from_mode)}
          </div>
        </Tooltip>
      </div>
    </div>
  );
}
